import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { useIntersection } from "../../Hooks/customHooks";
import { START_REPEAT_ORDER_PATIENT_FIELD_LIST } from "../../Actions/RepeatOrderAction";
import { CircularProgress, Grid, TextField, Button } from "@mui/material";
import "../../Sass/Common.scss";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  RepeatOrderAutocompleteListbox: {
    padding: "0px !important",
    // marginTop: "45px !important"
  },
});

function RepeatOrderPatientAutoComplete(props) {
  const {
    value,
    multiple,
    disabled,
    handleChange,
    repeatOrderPatientFieldList,
    getPatientFieldListAction,
    apiParams,
    disableEnter = true,
    maxValue,
    driverListFlag,
    helperText,
    error = false,
    maxVisibleChip = 1,
    currentPageType,
    orderType,
    buttonOptionTop,
    buttonTitle,
    handleButtonClick,
    textFieldProps = {
      required: true,
    },
    ...other
  } = props;
  const classes = useStyles();
  const [selectDrug, setSelectDrug] = useState(value || {});
  const [drugSearchString, setDrugSearchString] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const { loginUserDetail } = useSelector((state) => state.user);

  const [setTargetDrug, entryDrug] = useIntersection({
    threshold: 0.1,
  });
  const query = new URLSearchParams(window.location.search);

  /** get list call */
  useEffect(() => {
    if (
      query.get("actionType") === "create" ||
      currentPageType === "orderpad" ||
      orderType === "addOrder" ||
      orderType === "createNewOrder"
    ) {
      setIsOpen(true);
      let params = {
        offset: 0,
      };
      if (drugSearchString) {
        params.q = drugSearchString;
      }
      getPatientFieldListAction(params);
    }
  }, []);

  /** value set */
  useEffect(() => {
    if (multiple) {
      setSelectDrug(Object.values(value || {}));
    } else {
      setSelectDrug(value);
    }
  }, [value]);

  /** drug on entry */
  useEffect(() => {
    if (
      entryDrug.isIntersecting &&
      repeatOrderPatientFieldList.loading === false
    ) {
      let params = {
        offset: repeatOrderPatientFieldList?.data?.list?.length || 0,
        ...(drugSearchString && { q: drugSearchString }),
      };
      if (isOpen) {
        getPatientFieldListAction(params);
      }
    }
  }, [entryDrug]);

  /** search drug */
  const searchDrugDebounce = useRef(
    _.debounce((searchString, open) => {
      let params = {
        offset: 0,
      };
      if (searchString) {
        params.q = searchString;
      }
      if (open) {
        getPatientFieldListAction(params);
      }
    }, 500)
  );

  /** search drug name  */
  const handleSearchDrugName = (newValue) => {
    setDrugSearchString(newValue);
    searchDrugDebounce.current(newValue, isOpen);
  };

  /** fetch drug data */
  let fetchDrugData = () => {
    setIsOpen(true);
    let params = {
      offset: 0,
    };
    if (drugSearchString) {
      params.q = drugSearchString;
    }
    getPatientFieldListAction(params);
  };

  /** handle change drug listing */
  const handleChangeDrugListing = (event, newValue) => {
    let newList = {};
    if (multiple) {
      newValue.map((patient) => {
        newList[patient.id] = patient;
      });
    } else {
      newList = newValue;
    }
    setSelectDrug(newValue);
    handleChange && handleChange(newList);
  };

  /** Filter options with a custom button at the top of the list */
  const filterOptions = (options) => {
    let result = [...options];
    if (buttonOptionTop && !result.some((option) => option.type === "button")) {
      result = [{ type: "button" }, ...result];
    }
    if (
      repeatOrderPatientFieldList?.data?.list?.length <
      repeatOrderPatientFieldList?.data?.total
    ) {
      result.push("FinalOption");
    }
    return result || [];
  };

  return (
    <>
      <Autocomplete
        multiple={multiple}
        classes={{
          listbox: classes.RepeatOrderAutocompleteListbox,
          option: "option",
        }}
        disableCloseOnSelect={multiple}
        disabled={Boolean(disabled)}
        onOpen={fetchDrugData}
        open={isOpen}
        onClose={() => {
          searchDrugDebounce.current.cancel();
          setIsOpen(false);
        }}
        loading={repeatOrderPatientFieldList?.loading}
        noOptionsText={"No results found"}
        value={selectDrug}
        onChange={handleChangeDrugListing}
        options={repeatOrderPatientFieldList?.data?.list || []}
        getOptionLabel={(option) => {
          return !_.isEmpty(option)
            ? `${option.name} ${
                option.last_name != null ? option.last_name : ""
              } ${
                option.dob
              ? `( ${moment(new Date(option.dob)).format("DD-MM-YYYY")})`
              : ""
            }`
            : "";
        }}
        isOptionEqualToValue={(option, value) => {
          return option.id === value.id;
        }}
        onInputChange={(event, newValue) => {
          handleSearchDrugName(newValue);
        }}
        filterOptions={filterOptions}
        renderOption={(props, option, { selected }) => {
          if (buttonOptionTop && option.type === "button") {
            return (
              <Grid
                container
                alignItems="center"
                className="autoCompleteButton"
              >
                <Button
                  onClick={handleButtonClick}
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  {buttonTitle}
                </Button>
              </Grid>
            );
          } else {
            return (
              <React.Fragment>
                {typeof option === "object" ? (
                  <Grid {...props} key={option?.id}>
                    {option.name} &nbsp;
                    {option.last_name != null ? option.last_name : ""}{" "}
                    {option.dob
                      ? `(${moment(new Date(option.dob)).format("DD-MM-YYYY")})`
                      : ""}
                  </Grid>
                ) : (
                  <Grid className="autoCompleteInputLoader" ref={setTargetDrug}>
                    <CircularProgress size={20} />
                  </Grid>
                )}
              </React.Fragment>
            );
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            autoFocus
            helperText={helperText}
            InputLabelProps={{ required: false }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
              endAdornment: (
                <React.Fragment>
                  {repeatOrderPatientFieldList?.loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        {...other}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  repeatOrderPatientFieldList: state.order.repeatOrderPatientFieldList,
});

const mapDispatchToProps = (dispatch) => ({
  getPatientFieldListAction: (payload) =>
    dispatch({ type: START_REPEAT_ORDER_PATIENT_FIELD_LIST, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RepeatOrderPatientAutoComplete);
